import(/* webpackMode: "eager", webpackExports: ["PortfolioCardSkeleton"] */ "/home/r11/choice-graphics/src/components/v2/portfolio/portfolio-card.tsx");
